import React from 'react';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiGrid from '@material-ui/core/Grid';

import MuiPeopleIcon from '@material-ui/icons/PeopleOutline';
import MuiSwitch from '@material-ui/core/Switch';

function SplitDetail({ split }) {
  const {
    percentage,
    recoupAccountPassthroughs,
    payee: { full_name },
  } = split;
  return (
    <MuiTableRow>
      <MuiTableCell>
        <MuiPeopleIcon /> {full_name}
      </MuiTableCell>
      <MuiTableCell align="center">{percentage}%</MuiTableCell>
      <MuiTableCell align="right" size="small">
        {<MuiSwitch checked={recoupAccountPassthroughs?.length === 0} />}
      </MuiTableCell>
    </MuiTableRow>
  );
}

export default function TrackSplitDetails({ splits }) {
  return (
    <MuiAccordionDetails>
      <MuiGrid container>
        <MuiGrid item xs={10}>
          <MuiTableContainer>
            <MuiTable>
              <MuiTableHead>
                <MuiTableRow>
                  <MuiTableCell></MuiTableCell>
                  <MuiTableCell align="center">Split</MuiTableCell>
                  <MuiTableCell align="right">Recoup Against</MuiTableCell>
                </MuiTableRow>
              </MuiTableHead>
              <MuiTableBody>
                {splits.map(split => (
                  <SplitDetail key={split.id} split={split} />
                ))}
              </MuiTableBody>
            </MuiTable>
          </MuiTableContainer>
        </MuiGrid>
      </MuiGrid>
    </MuiAccordionDetails>
  );
}
